import React, { useContext, useState } from "react";
import trans from "../../../../utils";
import { ActionBtns } from "../TrackedQuickActions/TrackedQuickActions";
import SelectedControlsPopups from "../../../LiveTracking/ObjectSelected/SelectedControls/SelectedControlsPopups/SelectedControlsPopups";
import { popupcontext } from "../../../../context/Popupscontext";
import { useNavigate } from "react-router-dom";

export default function TrackedSelectedQuickActions({ device, details }) {
	const [title, setTitle] = useState(null);
	const { setIsControlsPopup } = useContext(popupcontext);
	const navigate = useNavigate();
	return (
		<>
			<div style={{ paddingInline: "12px", marginBottom: "4px" }}>
				<div style={{ fontWeight: 500, fontSize: "16px", marginBottom: "8px" }}>
					{trans("Quick Actions")}
				</div>
				<div className="row gy-1">
					<div className="col-lg-6">
						<ActionBtns
							title="Stop Engine"
							imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/PowerOff.svg`}
							styling="tracked-quick-actions-engine-off w-100"
							fun={() => setTitle("stop engine")}
						/>
					</div>
					<div className="col-lg-6">
						<ActionBtns
							title="Set Geofence"
							imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/Geofence.svg`}
							styling="tracked-quick-actions-btn w-100"
							fun={() => setTitle("set geofence")}
						/>
					</div>
					<div className="col-lg-6">
						<ActionBtns
							title="Speed Limit"
							imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/SpeedLimit.svg`}
							styling="tracked-quick-actions-btn w-100"
							fun={() => setTitle("set speed limit")}
						/>
					</div>
					<div className="col-lg-6">
						<ActionBtns
							title="History Playback"
							imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/HistoryPlayback.svg`}
							styling="tracked-quick-actions-btn w-100"
							fun={() => navigate(`/historyplayback/${device.id}`)}
						/>
					</div>
				</div>
			</div>
			<SelectedControlsPopups
				title={title}
				device={device}
				setControlsPopup={setTitle}
				setIsControlsPopup={setIsControlsPopup}
			/>
		</>
	);
}
